module.exports = __webpack_public_path__ + "static/media/sumaAsegurada_orange.1db02788.svg";